import React from 'react';

interface PageContainerProps {
  [x: string]: any;
}

const PageContainer = (props: PageContainerProps) => <main>{props.children}</main>;

export default PageContainer;
